// extracted by mini-css-extract-plugin
module.exports = {"viewers":"Viewers_viewers__2g5rW","header":"Viewers_header__lB1Ef","headerText":"Viewers_headerText__2YrUH","elements":"Viewers_elements__3fWYT"};